<template>
  <div>
    <el-card class="searchCon">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <!-- 客户编码 -->
            <el-form-item :label="$t('mdfeTranslate.CustomerCode')">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
                remote
                multiple
                collapse-tags
                reserve-keyword
                :remote-method="getCustomerOption"
                @visible-change="getCustomerOptionDialog"
              >
                <el-option
                  v-for="item in customerOption"
                  :key="item.id"
                  :label="item.username + '（' + item.id + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 创建人 -->
            <el-form-item :label="$t('collectionCenter.creator')">
              <el-select
                v-model.trim="queryForm.params.createUser"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getUserList"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                @visible-change="getUserListDialog"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.realName+'('+item.username+')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 状态 -->
            <el-form-item :label="$t('collectionCenter.stateZT')">
              <el-select
                v-model="queryForm.params.status" :placeholder="$t('GlobalSetObj.pleaseChoose')" style="width: 100%;"
                clearable
              >
                <!-- 启用 -->
                <el-option :label="$t('collectionCenter.enable')" :value="1" />
                <!-- 停用 -->
                <el-option :label="$t('collectionCenter.disable')" :value="0" />
                <!-- 暂存 -->
                <el-option :label="$t('collectionCenter.Stored')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <!-- 创建时间 -->
            <el-form-item :label="$t('collectionCenter.CreationTime')" class="numberSearch">
              <!--              <template slot="label">-->
              <!--                <el-select v-model="queryForm.params.timeType" :placeholder="$t('GlobalSetObj.pleaseChoose')">-->
              <!--                  &lt;!&ndash; 创建时间 &ndash;&gt;-->
              <!--                  <el-option :label="$t('collectionCenter.CreationTime')" :value="1" />-->
              <!--                  &lt;!&ndash; 更新时间 &ndash;&gt;-->
              <!--                  <el-option :label="$t('GlobalSetObj.UpdateTime')" :value="2" />-->
              <!--                </el-select>-->
              <!--              </template>-->
              <!--:picker-options="pickerOptions"-->
              <el-date-picker
                v-model="queryForm.params.invoiceIssueTime"
                type="datetimerange"
                range-separator="-"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin-top: 10px;">
          <!--查询-->
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="search"
          >{{ $t('basicData.Search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="onReset"
          >{{ $t('basicData.reset') }}
          </el-button>
          <!--新增-->
          <el-button
            v-permit:remove="'btn:invoiceCenter:customerInvoiceSubjectConfiguration-add'"
            size="mini" type="primary" @click="onViewEditDetail(null, 0)"
          >{{ $t('collectionCenter.add') }}
          </el-button>
          <!-- 导出 -->
          <el-button
            v-permit:remove="'btn:invoiceCenter:customerInvoiceSubjectConfiguration-onExport'"
            size="mini" type="primary" @click="onExport"
          >{{ $t('CenterForSorting.export') }}</el-button>
        </div>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
        @selection-change="handleSelectionChange"
      >
        <!--        <el-table-column-->
        <!--          type="selection"-->
        <!--          width="55"-->
        <!--          align="center"-->
        <!--          fixed="left"-->
        <!--        />-->
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.prop"
          :align="item.align"
          :label="item.label"
          :min-width="item.minWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'status'">
              <el-tag v-if="scope.row.status === 1" type="success" size="mini">{{ $t('collectionCenter.enable') }}</el-tag>
              <el-tag v-else-if="scope.row.status === 0" type="danger" size="mini">{{ $t('collectionCenter.disable') }}</el-tag>
              <el-tag v-else type="info" size="mini">{{ $t('collectionCenter.Stored') }}</el-tag>
            </div>
            <div v-else-if="item.prop === 'businessType'">
              <div v-if="scope.row.businessType === 0">{{ $t('collectionCenter.expressDelivery') }}</div>
              <div v-if="scope.row.businessType === 1">{{ $t('collectionCenter.lanshou') }}</div>
              <div v-if="scope.row.businessType === 2">{{ $t('basicData.StockingAndPickup') }}</div>
            </div>
            <div v-else-if="item.prop === 'tomaCfop'">
              <div style="display: flex">
                <div v-if="scope.row[item.prop] && scope.row[item.prop].length > 0">
                  <el-tag size="mini" type="success">{{ scope.row[item.prop][0] }}</el-tag>
                </div>
                <el-popover
                  placement="top-start"
                  trigger="hover"
                >
                  <div>
                    <template v-for="(list, index) in scope.row[item.prop]">
                      <div v-if="index !== 0" :key="index" style="margin-bottom: 5px;">{{ list }}</div>
                    </template>
                  </div>
                  <div v-if="scope.row[item.prop] && scope.row[item.prop].length > 1" slot="reference" style="margin-left: 5px;">
                    +<el-tag size="mini" style="border-radius: 50%" type="info">{{ scope.row[item.prop].length - 1 }}</el-tag>
                  </div>
                </el-popover>
              </div>
            </div>
            <div v-else-if="item.prop === 'tomaTpServ'">
              <div style="display: flex">
                <div v-if="scope.row[item.prop] && scope.row[item.prop].length > 0"><el-tag size="mini" type="success">{{ scope.row[item.prop][0] }}</el-tag></div>
                <el-popover
                  placement="top-start"
                  trigger="hover"
                >
                  <div>
                    <template v-for="(list, index) in scope.row[item.prop]">
                      <div v-if="index !== 0" :key="index" style="margin-bottom: 5px;">{{ list }}</div>
                    </template>
                  </div>
                  <div v-if="scope.row[item.prop] && scope.row[item.prop].length > 1" slot="reference" style="margin-left: 5px;">
                    +<el-tag size="mini" style="border-radius: 50%" type="info">{{ scope.row[item.prop].length - 1 }}</el-tag>
                  </div>
                </el-popover>
              </div>
            </div>
            <div v-else>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('collectionCenter.operation')"
          align="center"
          fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              trigger="hover"
            >
              <el-button slot="reference" size="mini" type="text">
                <i class="el-icon-more" style="font-size: 26px" />
              </el-button>
              <div>
                <div
                  v-permit:remove="'btn:invoiceCenter:customerInvoiceSubjectConfiguration-view'"
                  style="margin-bottom: 10px;"
                >
                  <el-button
                    size="mini" type="primary" @click="onViewEditDetail(scope.row, 1)"
                  >{{ $t('collectionCenter.View') }}</el-button><!--查看-->
                </div>
                <div
                  v-if="scope.row.status === 0 || scope.row.status === 2"
                  v-permit:remove="'btn:invoiceCenter:customerInvoiceSubjectConfiguration-edit'"
                  style="margin-bottom: 10px;"
                >
                  <el-button
                    size="mini" type="primary" @click="onViewEditDetail(scope.row, 2)"
                  >{{ $t('collectionCenter.edit') }}</el-button><!-- 编辑 -->
                </div>
                <div v-permit:remove="'btn:invoiceCenter:customerInvoiceSubjectConfiguration-disableEnable'">
                  <div v-if="scope.row.status === 1">
                    <el-button
                      size="mini" type="danger" @click="onDisableEnable(scope.row)"
                    >{{ $t('collectionCenter.Disable') }}</el-button><!-- 停用 -->
                  </div>
                  <div v-if="scope.row.status === 0">
                    <el-button
                      size="mini" type="success" @click="onDisableEnable(scope.row)"
                    >{{ $t('collectionCenter.enable') }}</el-button><!-- 启用 -->
                  </div>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <el-drawer
      :title="viewType === 1 ? $t('collectionCenter.View') : $t('collectionCenter.edit')"
      :visible.sync="showDetailWindow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      direction="ltr"
      size="100vw"
      @close="onCloseDetailWindow"
    >
      <view-detail
        ref="viewDetailRef"
        :key="detailKey"
        :view-type="viewType"
        :form-element="formElement"
        :form-element-fixed="formElementFixed"
        @closeDetail="closeDetail"
      />
    </el-drawer>
  </div>
</template>

<script>
// import dayjs from 'dayjs';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';
import viewDetail from './cmp/newViewDetail.vue';
import { getUserPage } from '@/api/user';
import {
  exportInvoiceSubject,
  getNewInvoiceSubjectPage,
  getNewInvoiceSubjectForm,
  deleteNewInvoiceSubject
} from '@/api/invoiceCenter';
import { apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import { goResourceTaskList } from '@/utils/goExportList';
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
// const startTe = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
// const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间im
export default {
  name: 'NewCustomerInvoiceSubjectConfiguration',
  components: { viewDetail },
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          customerIds: [],
          createUser: null,
          status: null,
          invoiceIssueTime: []
        }
      },
      pickerMinDate: '',
      pickerRange: 14 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      tableData: [],
      total: 0,
      selectedData: [],
      tableHeaderList: [
        // '客户编码'
        { label: this.$t('mdfeTranslate.CustomerCode'), prop: 'customerId', minWidth: 180, align: 'center' },
        // '账号名称'
        { label: this.$t('customerManagements.AccountName'), prop: 'customerName', minWidth: 200, align: 'center' },
        // 状态
        { label: this.$t('collectionCenter.stateZT'), prop: 'status', minWidth: 120, align: 'center' },
        // 业务类型
        { label: this.$t('collectionCenter.businessT'), prop: 'businessType', minWidth: 120, align: 'center' },
        // CFOP
        { label: 'CFOP', prop: 'tomaCfop', minWidth: 180, align: 'center' },
        // 服务类型
        { label: this.$t('GlobalSetObj.serviceTypes'), prop: 'tomaTpServ', minWidth: 200, align: 'center' },
        // '创建人'
        { label: this.$t('collectionCenter.creator'), prop: 'createUserName', minWidth: 180, align: 'center' },
        // 创建时间
        { label: this.$t('collectionCenter.CreationTime'), prop: 'createTime', minWidth: 180, align: 'center' },
        // 修改人
        { label: this.$t('userManage.ModifyThePerson'), prop: 'updateUserName', minWidth: 180, align: 'center' },
        // 修改时间
        { label: this.$t('CenterForSorting.ModificationTime'), prop: 'updateTime', minWidth: 180, align: 'center' }
      ],
      userList: [],
      customerOption: [],
      showDetailWindow: false,
      detailKey: new Date().getTime(),
      viewType: 0, // 0: 新增 1: 查看详情 2: 编辑详情
      formElementFixed: null,
      formElement: null
    };
  },
  created() {
    // this.getFormElement();
    this.getUserList();
    this.getCustomerOption();
    // this.search();
    this.getInit();
  },
  methods: {
    async getInit() {
      const { data } = await getNewInvoiceSubjectForm();
      this.formElementFixed = JSON.parse(data.form);
      this.search();
    },
    // 启用、禁用
    onDisableEnable(row) {
      const param = {
        id: row.id,
        status: row.status === 1 ? 0 : 1
      };
      const msg = row.status === 1 ? this.$t('basicData.AreYouSureDisabled') : this.$t('basicData.AreYouSureEnabled');
      this.$confirm(msg, this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      }).then(async() => {
        deleteNewInvoiceSubject(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('operationCenter.TheOperationSucceeded'));
            this.getTableData();
          }
        });
      });
    },
    // 关闭编辑弹窗
    onCloseDetailWindow() {
      this.$refs.viewDetailRef.onCloseZipCode();
    },
    closeDetail(type) {
      this.showDetailWindow = false;
      if (type) {
        this.getTableData();
      }
    },
    // 客户选项弹窗打开
    getCustomerOptionDialog(val) {
      if (val) {
        this.getCustomerOption();
      }
    },
    // 获取客户选项
    getCustomerOption(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          userNameOrId: name
        }
      };
      apiGetCustomerPage(param).then(res => {
        if (res.code === 200) {
          this.customerOption = res.data.records;
        }
      });
    },
    // 查询条件整理
    queryParam() {
      const { customerIds, createUser, status, invoiceIssueTime } = this.queryForm.params;
      const params = {
        customerIds: customerIds || [],
        createUser: createUser !== null && createUser !== '' && createUser !== undefined ? createUser : null,
        status: status !== null && status !== '' && status !== undefined ? status : null,
        startTime: null,
        endTime: null
      };
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        params.startTime = invoiceIssueTime[0];
        params.endTime = invoiceIssueTime[1];
      }
      return params;
    },
    // 获取表单元素
    getFormElement() {
      getNewInvoiceSubjectForm().then(res => {
        this.formElementFixed = JSON.parse(res.data.form);
        console.log(this.formElementFixed, '====this.5555555');
      });
    },
    // 获取列表数据
    getTableData() {
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      getNewInvoiceSubjectPage(queryParam).then(res => {
        if (res.code === 200) {
          const tpServMap = {};
          if (this.formElementFixed) {
            this.formElementFixed.toma[0].column.map(item => {
              if (item.field === 'tpServ') {
                item.options.map(list => {
                  tpServMap[Number(list.value)] = {
                    label: list.label,
                    value: Number(list.value)
                  };
                });
              }
            });
          }
          this.tableData = res.data.records.map((item) => {
            const createUserName = getUserName(item.createUser, getUserIdAndNameObj());
            const updateUserName = getUserName(item.updateUser, getUserIdAndNameObj());
            const formItem = JSON.parse(item.form);
            const tomaCfopList = formItem.toma.map(itemList => itemList.cfop);
            const tomaTpServList = formItem.toma.map(itemList1 => {
              if ((itemList1.tpServ || itemList1.tpServ === 0) && !isNaN(Number(itemList1.tpServ))) {
                return tpServMap[Number(itemList1.tpServ)].label;
              } else {
                return itemList1.tpServ;
              }
            });
            const tomaTpServ = [];
            tomaTpServList.map(itemServ => {
              if (tomaTpServ.includes(itemServ) === false) {
                tomaTpServ.push(itemServ);
              }
            });
            const tomaCfop = [];
            tomaCfopList.map(itemCfop => {
              if (tomaCfop.includes(itemCfop) === false) {
                tomaCfop.push(itemCfop);
              }
            });
            return {
              ...item,
              tomaCfop,
              tomaTpServ,
              createUserName,
              updateUserName
            };
          });
          console.log(this.tableData, '====this.tableData==');
          this.total = res.data.total;
        }
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 重置
    onReset() {
      this.queryForm.params = {
        customerIds: [],
        createUser: null,
        status: null,
        invoiceIssueTime: []
      };
      this.getTableData();
    },
    // 导出
    onExport() {
      // const queryParam = {
      //   pageSize: this.queryForm.pageSize,
      //   pageNumber: this.queryForm.pageNumber,
      //   params: this.queryParam()
      // };
      exportInvoiceSubject(this.queryParam()).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 数据勾选
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    // 每页显示数量改变时触发
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 当前页码改变时触发
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 将详情的值与栏目字段绑定
    updateFormElementWithRowFormData(rowForm, formElement) {
      const updatedFormElement = {};

      // 遍历rowForm中的每个模块，只处理rowForm中存在的模块
      for (const moduleKey in formElement) {
        // 初始化updatedFormElement中对应模块的数组
        updatedFormElement[moduleKey] = [];
        if (this.viewType !== 0) {
          // eslint-disable-next-line no-prototype-builtins
          if (rowForm.hasOwnProperty(moduleKey) && Array.isArray(rowForm[moduleKey])) {
            // 只有当formElement中也存在该模块时，才处理该模块
            if (formElement[moduleKey] && Array.isArray(formElement[moduleKey])) {
              const rowModuleArray = rowForm[moduleKey];
              const formModuleArray = formElement[moduleKey];
              // 遍历rowModuleArray（而不是formModuleArray），确保所有row数据都被处理
              for (let i = 0; i < rowModuleArray.length; i++) {
                const rowItem = rowModuleArray[i];

                // 根据索引获取对应的formModule配置，如果索引超出范围则使用最后一个配置
                const formItem = formModuleArray[Math.min(i, formModuleArray.length - 1)];

                // 创建新项，基于formItem的结构，保留所有字段和配置，仅更新值
                const newItem = { column: [] };

                // 保留formItem的其他配置，如titleOption
                if (formItem && formItem.titleOption) {
                  newItem.titleOption = formItem.titleOption;
                }

                if (formItem && formItem.column && Array.isArray(formItem.column)) {
                  // 遍历formItem中的每个字段，保留所有字段和配置并更新值
                  for (let j = 0; j < formItem.column.length; j++) {
                    const formColumn = formItem.column[j];

                    // 检查该字段是否在rowItem中存在（忽略大小写）
                    const fieldInRowItem = Object.keys(rowItem || {}).find(key =>
                      key.toLowerCase() === formColumn.field.toLowerCase()
                    );

                    // 创建新的字段对象，保留formColumn的所有配置
                    const newColumn = { ...formColumn };

                    if (fieldInRowItem && rowItem) {
                      // 如果字段存在，更新值
                      newColumn.value = rowItem[fieldInRowItem];
                    } else {
                      // 如果字段不存在，保持原来的值或设置为空
                      newColumn.value = formColumn.value || '';
                    }

                    newItem.column.push(newColumn);
                  }
                }
                updatedFormElement[moduleKey].push(newItem);
              }
            }
          }
        }
      }
      return updatedFormElement;
    },
    // 查看、编辑详情
    onViewEditDetail(row, type) {
      this.viewType = type;
      const formElementFixed = JSON.parse(JSON.stringify(this.formElementFixed));
      if (type !== 0) {
        const rowForm = JSON.parse(row.form);
        // 更新formElement的值
        this.formElement = {
          customerId: row.customerId,
          customerName: row.customerName,
          id: row.id,
          businessType: row.businessType,
          status: row.status,
          elementForm: this.updateFormElementWithRowFormData(rowForm, formElementFixed)
        };
        this.$nextTick(() => {
          this.showDetailWindow = true;
          this.detailKey = new Date().getTime();
        });
      } else {
        this.formElement = {
          customerId: '',
          customerName: '',
          id: '',
          businessType: null,
          status: 0,
          elementForm: this.updateFormElementWithRowFormData(null, formElementFixed) // JSON.parse(JSON.stringify(this.formElementFixed))
        };
        this.$nextTick(() => {
          this.showDetailWindow = true;
          this.detailKey = new Date().getTime();
        });
      }
    },
    // 获取用户列表
    getUserList(usernameLike = '') {
      const param = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountState: '1',
          usernameLike
        }
      };
      getUserPage(param, false).then((res) => {
        if (res.code === 200) {
          this.userList = res.data.records;
        }
      });
    },
    // 创建人选项弹窗打开
    getUserListDialog(val) {
      if (val) {
        this.getUserList();
      }
    }
  }
};
</script>

<style>
.numberSearch .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
.searchCon .el-form-item {
  margin-bottom: 0 !important;
}
</style>
